module.exports = __webpack_public_path__ + "img/wemlo-leads.84c0c9c8.png";